import HrDashboard from './HrDashboard'

export default HrDashboard
